import { forwardRef, type ButtonHTMLAttributes } from 'react';
export interface KitButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'quiet';
  size?: 'md' | 'lg';
}
export const KitButton = forwardRef<HTMLButtonElement, KitButtonProps>(function KitButton(
  { variant = 'secondary', size = 'md', type = 'button', className = '', ...props },
  ref,
) {
  return (
    <button
      {...props}
      ref={ref}
      type={type}
      className={`pc-btn pc-app-button ${className}`.trim()}
      data-variant={variant}
      data-size={size}
    />
  );
});
